export type { IStyleFunction } from '@fluentui/merge-styles';
